"use strict";

exports.__esModule = true;
exports.getDefaultStaffMemberId = void 0;
var _service = require("../service/service");
var _constants = require("../../constants");
var _calculatePreferencesView = require("../../utils/calculatePreferencesView/calculatePreferencesView");
var _bookingsCalendarCatalogViewerMapper = require("@wix/bookings-calendar-catalog-viewer-mapper");
var _sortStaff = require("./sortStaff");
var _getQueryParams = require("../../utils/getQueryParams");
const getDefaultStaffMemberId = ({
  service,
  bookingsSettings,
  experiments,
  serviceOptionsAndVariants,
  openedBy,
  queryParams
}) => {
  var _service$staffMembers, _service$staffMembers2, _sortedStaffMembers$;
  const isBookFlowSettingsEnabled = (0, _bookingsCalendarCatalogViewerMapper.isBookFlowSettingsEnabled)({
    experiments,
    bookingsSettings
  });
  const preferencesView = (0, _calculatePreferencesView.calculatePreferencesViewForAppointment)({
    service,
    bookingsSettings,
    serviceOptionsAndVariants,
    openedBy,
    queryParams
  });
  const staffMemberDisplayOnCalendar = isBookFlowSettingsEnabled && preferencesView[_calculatePreferencesView.PreferenceType.STAFF_MEMBER] === _calculatePreferencesView.DisplayTarget.CALENDAR;
  const hasNoStaffMembers = !((_service$staffMembers = service.staffMembers) != null && _service$staffMembers.length);
  if (staffMemberDisplayOnCalendar || hasNoStaffMembers) {
    return;
  }
  const resourceFromUrl = (0, _getQueryParams.getResourceFromUrl)(queryParams);
  if (resourceFromUrl) {
    return resourceFromUrl;
  }
  if ((0, _service.canAutoAssignStaff)(service, bookingsSettings, experiments, serviceOptionsAndVariants)) {
    return _constants.DO_NOT_CARE_STAFF;
  }
  const sortedStaffMembers = (_service$staffMembers2 = service.staffMembers) == null ? void 0 : _service$staffMembers2.sort((0, _sortStaff.sortStaff)({
    service,
    serviceOptionsAndVariants
  }));
  return sortedStaffMembers == null || (_sortedStaffMembers$ = sortedStaffMembers[0]) == null ? void 0 : _sortedStaffMembers$.staffMemberId;
};
exports.getDefaultStaffMemberId = getDefaultStaffMemberId;
//# sourceMappingURL=getDefaultStaffId.js.map